import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import logoWhite from "../../assets/general/logo-white.svg";
import mobileMenu from "../../assets/general/mobile-menu.svg";
import arrowBack from "../../assets/general/arrow-top.svg";
import { SideNav } from "./SideNav/SideNav";

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
    <SideNav />
    <div className="legal-container right-menu-padding">
      <div className="legal-goback-container">
        <img
          className="legal-coback"
          src={arrowBack}
          alt="go back"
          onClick={() => navigate(-1)}
          style={{ cursor: "pointer" }}
        />
      </div>
      <div className="embed-header-container">
        <Link className="logo" to="/">
          <div className="logo__wrapper-img">
            <img className="logo-img" src={logoWhite} alt="360PLUS Website" />
          </div>
        </Link>
        <img
          className="mobile-menu-selector"
          src={mobileMenu}
          alt="360PLUS Menu"
          onClick={() => setMenuOpen(!menuOpen)}
          style={{ cursor: "pointer" }}
        />
      </div>
      {children}
    </div>
    </>
  );
}
